(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-cards-slider"] && !Shopify.designMode) return;
  try {
    
    const section = document.querySelector('.custom-cards-slider');

    const slidesPerView = parseFloat(section.dataset.swiperSlidesPerView) || 1;
    const slidesPerViewMobile = parseFloat(section.dataset.swiperSlidesPerViewMobile) || 1;
    const gap = parseInt(section.dataset.swiperGap) || 0;

    const swiper = new Swiper('.swiper', {
        direction: 'horizontal',
        loop: true,
        spaceBetween: gap,
        slidesPerView: slidesPerViewMobile,
        breakpoints: {
            768: {
            slidesPerView: slidesPerView,
            }
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hero-slideshow')) {
    class HeroSlideshow extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.hs-slide'));
        this.dots = Array.from(this.querySelectorAll('.hs-dot'));
        this.index = Math.max(0, this.slides.findIndex((s) => s.classList.contains('is-active')));
        this.autoplay = this.dataset.autoplay === 'true';
        this.isFade = this.classList.contains('hs--fade');
        this.holds = new Set();

        this.slides.forEach((slide) => {
          slide.querySelectorAll('.hs-anim').forEach((el, i) => el.style.setProperty('--hs-i', i));
        });
        if (this.slides[this.index]) this.slides[this.index].classList.add('is-first-paint');

        this.initHeight();
        if (this.slides.length < 2) return;

        requestAnimationFrame(() => this.classList.add('is-ready'));
        this.syncMedia();
        this.bind();
      }

      disconnectedCallback() {
        if (this.io) this.io.disconnect();
        if (this.ro) this.ro.disconnect();
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
        if (this.onSelect) {
          document.removeEventListener('shopify:block:select', this.onSelect);
          document.removeEventListener('shopify:block:deselect', this.onDeselect);
        }
      }

      bind() {
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(+dot.dataset.index)));
        this.querySelectorAll('.hs-arrow').forEach((btn) =>
          btn.addEventListener('click', () => this.go(this.index + +btn.dataset.dir, +btn.dataset.dir))
        );

        // The active dot's fill animation is the autoplay timer, so pausing it pauses autoplay
        this.addEventListener('animationend', (e) => {
          if (e.animationName === 'hs-progress' && this.autoplay) this.go(this.index + 1, 1);
        });

        this.addEventListener('mouseenter', () => this.hold('hover'));
        this.addEventListener('mouseleave', () => this.release('hover'));
        this.addEventListener('focusin', () => this.hold('focus'));
        this.addEventListener('focusout', () => this.release('focus'));
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.go(this.index - 1, -1);
          if (e.key === 'ArrowRight') this.go(this.index + 1, 1);
        });

        this.onVisibility = () => (document.hidden ? this.hold('tab') : this.release('tab'));
        document.addEventListener('visibilitychange', this.onVisibility);
        this.io = new IntersectionObserver(([entry]) =>
          entry.isIntersecting ? this.release('offscreen') : this.hold('offscreen')
        );
        this.io.observe(this);

        // Swipe. Vertical scrolling stays native (touch-action: pan-y)
        let x0 = null, y0 = 0, swiped = false;
        this.addEventListener('pointerdown', (e) => {
          if (e.pointerType === 'mouse') return;
          x0 = e.clientX; y0 = e.clientY; swiped = false;
        });
        this.addEventListener('pointerup', (e) => {
          if (x0 === null) return;
          const dx = e.clientX - x0, dy = e.clientY - y0;
          x0 = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
            swiped = true;
            this.go(this.index + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
          }
        });
        this.addEventListener('pointercancel', () => (x0 = null));
        this.addEventListener('click', (e) => { if (swiped) { e.preventDefault(); swiped = false; } }, true);

        // Theme editor: show the slide being edited and stop autoplay while editing
        if (window.Shopify && Shopify.designMode) {
          this.onSelect = (e) => {
            if (!this.contains(e.target)) return;
            const slide = e.target.closest('.hs-slide');
            if (!slide) return;
            this.hold('editor');
            this.go(this.slides.indexOf(slide), undefined, true);
          };
          this.onDeselect = (e) => { if (this.contains(e.target)) this.release('editor'); };
          document.addEventListener('shopify:block:select', this.onSelect);
          document.addEventListener('shopify:block:deselect', this.onDeselect);
        }
      }

      hold(reason) { this.holds.add(reason); this.classList.add('is-paused'); }
      release(reason) {
        this.holds.delete(reason);
        if (!this.holds.size) this.classList.remove('is-paused');
      }

      go(target, dir, instant) {
        const n = this.slides.length;
        const next = ((target % n) + n) % n;
        if (next === this.index) return;
        if (dir === undefined) dir = next > this.index ? 1 : -1;

        const from = this.slides[this.index];
        const to = this.slides[next];
        this.slides.forEach((s) => s.classList.remove('is-first-paint'));

        clearTimeout(this.leaveTimer);
        this.slides.forEach((s) => { if (s !== from && s !== to) s.classList.remove('is-leaving'); });

        if (this.isFade) {
          to.classList.add('hs-enter');
        } else {
          // Park the incoming slide on the side it enters from, with no transition
          to.classList.add('hs-no-trans');
          to.style.transform = `translateX(${dir * 100}%)`;
        }
        void to.offsetWidth;

        from.classList.remove('is-active');
        from.classList.add('is-leaving');
        from.setAttribute('aria-hidden', 'true');
        from.inert = true;

        to.classList.remove('hs-no-trans');
        to.classList.add('is-active');
        to.removeAttribute('aria-hidden');
        to.inert = false;

        if (this.isFade) {
          void to.offsetWidth;
          to.classList.remove('hs-enter');
        } else {
          to.style.transform = '';
          from.style.transform = `translateX(${dir * -100}%)`;
        }
        if (instant) { from.classList.add('hs-no-trans'); to.classList.add('hs-no-trans'); }

        this.leaveTimer = setTimeout(() => {
          from.classList.remove('is-leaving', 'hs-no-trans');
          from.style.transform = '';
          to.classList.remove('hs-no-trans');
        }, instant ? 0 : 950);

        this.index = next;
        this.dataset.controls = to.dataset.controls || 'light';
        this.dots.forEach((d, i) => {
          d.classList.toggle('is-active', i === next);
          if (i === next) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        });
        // Restart the progress animation on the new active dot
        const fill = this.dots[next] && this.dots[next].querySelector('.hs-dot__fill');
        if (fill) { fill.style.animation = 'none'; void fill.offsetWidth; fill.style.animation = ''; }

        this.syncMedia();
      }

      syncMedia() {
        this.slides.forEach((s, i) => {
          s.querySelectorAll('video').forEach((v) => {
            if (i === this.index) { const p = v.play(); if (p && p.catch) p.catch(() => {}); }
            else v.pause();
          });
        });
      }

      // Same height handling as the hero section: --hero-top-offset for the transparent
      // header, and a pinned pixel height on mobile so in-app browsers can't resize it.
      initHeight() {
        const wrapper = this.closest('.thg-hero-wrapper') || this;
        const setOffset = () => {
          let offset = wrapper.getBoundingClientRect().top + window.scrollY;
          if (offset > 200) offset = 0;
          this.style.setProperty('--hero-top-offset', offset + 'px');
        };
        setOffset();
        window.addEventListener('resize', setOffset);
        this.ro = new ResizeObserver(setOffset);
        this.ro.observe(document.documentElement);

        const hVh = +this.dataset.heightMobile, minH = +this.dataset.minHeightMobile, margin = +this.dataset.margin;
        let top = null, frozen = false;
        const pin = () => {
          if (window.innerWidth > 768 || !hVh) return;
          if (!frozen) {
            const o = wrapper.getBoundingClientRect().top + window.scrollY;
            top = o > 200 || o < 0 ? 0 : o;
          }
          const inApp = /Instagram|FBAN|FBAV|FB_IAB|Line|TikTok/i.test(navigator.userAgent || '');
          const base = (window.visualViewport && window.visualViewport.height) || window.innerHeight;
          let px = Math.round((base - (inApp ? 80 : 0)) * (hVh / 100)) - top - margin;
          if (px < minH) px = minH;
          if (px > 200) this.style.height = px + 'px';
        };
        pin();
        window.addEventListener('load', () => requestAnimationFrame(() => { pin(); frozen = true; }));
        window.addEventListener('orientationchange', () => setTimeout(pin, 200));
      }
    }
    customElements.define('hero-slideshow', HeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();
})();
